
import { useEffect, useState } from "react";
import useProjects from "../../../hooks/useProjects";
import { FilledButton, OutlinedButton } from "../../common/Button";
import Lightbox from "../../common/Lightbox";
import useDisplayNotifications from "../../../hooks/useDisplayNotifications";
import { DisplayNotificationType } from "../../../models/DisplayNotification";
import useTasks from "../../../hooks/useTasks";
import { ETaskStatus, ITask } from "../../../data_models/task";
import TextInputArea from "../../common/TextInputArea";
import TextInputField from "../../common/TextInputField";
import useMyTasks from "../../../hooks/useMyTasks";
import useConfig from "../../../hooks/useConfig";


interface ProvideDeliveryLightboxProps {
    onClose: () => void;
    task: ITask;
    onUpdateTask: (updatedTask: ITask) => void;
}

const ProvideDeliveryLightbox: React.FC<ProvideDeliveryLightboxProps> = ({ onClose, task, onUpdateTask }) => {

    const [loading, setLoading] = useState(false);

    const { config } = useConfig();
    const { updateStatus } = useTasks();
    const { addSuccessNotification, addErrorNotification } = useDisplayNotifications();

    const onSubmit = async () => {
        setLoading(true);
        try {
            const newTask = await updateStatus(task._id!, ETaskStatus.DELIVERY_PROVIDED);
            if (newTask) {
                onUpdateTask(newTask);
            }
            addSuccessNotification('Successfully marked as delivery provided');
        } catch (error: any) {
            addErrorNotification(error.message);
        }
        setLoading(false);
        onClose();
    }

    return (
        <Lightbox
            header="Mark as Delivered"
            onConfirm={onSubmit}
            loadingConfirm={loading}
            onCancel={onClose}
            confirmText="Mark as Delivered"

            content={
                <p>This lets the project manager know your work is ready for review. Once submitted, they can request up to {config?.maxAmountOfTaskRevisions || 3} revisions if needed.                    </p>
            }
            onClose={onClose}
        />

    );
}

export default ProvideDeliveryLightbox;